import styled from 'styled-components';

import { NewStyleColor } from '../../../utils/styles-constants';
import { hexToRgba } from '../../../utils/style';

interface CellProps {
	isFirst: boolean;
}

interface IconProps {
	isChecked: boolean;
}

const Wrapper = styled('div')`
	display: table;
	width: 100%;
	margin-bottom: -4px;
`;

const Row = styled('div')`
	display: table-row;
`;

const Cell = styled('div')`
	box-sizing: border-box;
	display: table-cell;
	height: 60px;
	padding: 10px 15px;
	border-bottom: 1px solid ${hexToRgba(NewStyleColor.Black, 10)};
	vertical-align: middle;

	${(props: CellProps) => props.isFirst && `
		width: 1px;
		white-space: nowrap;
	`}
`;

const Label = styled('div')`
	padding-right: 20px;
	font-family: HelveticaNeue, sans-serif;
	font-size: 16px;
	line-height: 20px;
	color: ${hexToRgba(NewStyleColor.Black, 50)};
	text-transform: capitalize;
`;

const Icon = styled('div')`
	box-sizing: border-box;
	width: 30px;
	height: 30px;
	border-radius: 50%;

	${(props: IconProps) => !props.isChecked && `border: 2px solid ${hexToRgba(NewStyleColor.Black, 10)};`}

	input {
		display: none;
	}

	label {
		display: block;
		width: 30px;
		height: 30px;
		cursor: pointer;
	}

	svg {
		width: 30px;
		height: 30px;
		fill: ${NewStyleColor.VibrantGreen};
	}
`;

export {
	Wrapper,
	Row,
	Cell,
	Label,
	Icon,
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/ProfilePage/CRMSelector/styles.ts